import { render } from "./RetailerDrawer.vue?vue&type=template&id=5dc4f99a&scoped=true"
import script from "./RetailerDrawer.vue?vue&type=script&lang=js"
export * from "./RetailerDrawer.vue?vue&type=script&lang=js"

import "./RetailerDrawer.vue?vue&type=style&index=0&id=5dc4f99a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc4f99a"]])

export default __exports__